import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const ProgressMeta: ComponentMeta = {
  componentName: "Progress",
  package: "@mijadesign/web",
  title: "进度条",
  description: "展示操作的进度",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "LoadingOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "percent",
      label: "百分比",
      type: PropType.NUMBER,
      defaultValue: 50,
      group: "基础",
    },
    {
      name: "type",
      label: "类型",
      type: PropType.ENUM,
      defaultValue: "line",
      options: [
        { label: "线型", value: "line" },
        { label: "圆形", value: "circle" },
        { label: "仪表盘", value: "dashboard" },
      ],
      group: "样式",
    },
    {
      name: "showInfo",
      label: "显示信息",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
  ],
  defaultProps: {
    percent: 50,
    type: "line",
    showInfo: true,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Progress",
  },
  snippet: {
    componentName: "Progress",
    package: "@mijadesign/web",
    props: { percent: 50 },
  },
};
